import {
    Component,
    ViewEncapsulation,
    ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'lib-tabellarische-maske-table',
    imports: [],
    templateUrl: './tabellarische-maske-table.component.html',
    styleUrl: './tabellarische-maske-table.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class TabellarischeMaskeTableComponent {}
